// ------------------------------------
// Constants
// ------------------------------------
export const initialState: State.CareerStages = {
  careerStagesHash: null,
  error: null,
  careerStagesFetched: false,
};
